
























































import { Vue, Component, Model, Prop, Watch } from 'vue-property-decorator';
import RootElement from '@/components/common/RootElement.vue';
@Component({
  components: { RootElement },
})
export default class CompCheckBoxButton extends Vue {
  @Prop({ required: true }) private checkboxOptions!: any;
  @Prop() private disabled?: boolean;
  @Prop({ default: false }) private nonI18nConvert!: boolean;
  @Prop({ default: false }) private twoWayBind!: boolean;
  @Prop({ default: 'div' })
  private tag!: string;
  @Model('change') readonly value!: string;
  @Watch('valueArr.length', { immediate: false, deep: false })
  length(next: number) {
    this.checkAllCheck(next);
    let totalCount = this.checkboxOptions.data.length;
    totalCount = this.checkboxOptions.hasAll ? totalCount - 1 : totalCount;
    this.$emit('change', this.valueArr.length === totalCount ? 'ALL' : this.valueArr.toString());
  }
  private checkAll = true;
  private valueArr: string[] = [];

  private handleCheckAll(): void {
    if (!this.checkAll) {
      this.initValueArr();
    } else {
      this.valueArr = [];
    }
  }
  initValueArr() {
    this.valueArr = [];
    this.checkboxOptions.data.forEach((item: any, index: number) => {
      if (!this.checkboxOptions.hasAll || index !== 0) {
        this.valueArr.push(item.value);
      }
    });
  }
  private checkAllCheck(e: number): void {
    let length = this.checkboxOptions.data.length;
    length = this.checkboxOptions.hasAll ? length - 1 : length;
    if (e === length) {
      this.checkAll = true;
    } else {
      this.checkAll = false;
    }
  }
  public focus() {
    if (this.checkboxOptions.hasAll) {
      (this.$refs.checkbox_all as any)[0].focus();
    } else {
      (this.$refs.checkbox_no_all as any)[0].focus();
    }
  }
  public setValues(val: string) {
    if (val === 'ALL' && this.checkboxOptions.hasAll) {
      this.checkAll = true;
      this.initValueArr();
    } else {
      this.checkAll = false;
      this.valueArr = [];
      this.valueArr.push(...val.split(',').filter((item: string) => item !== ''));
    }
  }
  mounted() {
    this.setValues(this.value);
  }
  @Watch('value')
  changeValue(val) {
    if (this.twoWayBind) this.setValues(val);
  }
}
